import { MaskitoOptions } from '@maskito/core';
import { useMaskito } from '@maskito/react';
import { TextInput, TextInputProps } from '@spark-web/text-input';
import { RefCallback } from 'react';

type MaskedTextInputProps = TextInputProps & {
  ref?: RefCallback<HTMLElement | null>;
  maskitoOptions: MaskitoOptions;
};

const noop = (): void => {
  // intentionally left blank as it's a noop
};

export const MaskedTextInput = ({ maskitoOptions, onChange, ref: rootRef, ...props }: MaskedTextInputProps) => {
  const maskitoRef = useMaskito({ options: maskitoOptions });

  const ref: RefCallback<HTMLElement | null> = (node) => {
    maskitoRef(node);
    if (rootRef) {
      rootRef(node);
    }
  };

  // onInput is the recommended handler for Maskito; noop in onChange to avoid double-handling
  return <TextInput {...props} ref={ref} onInput={onChange} onChange={noop} />;
};
